import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "pages/inicio/Home";
import Registro from "pages/inicio/Registro";
import Login from "pages/inicio/Login";
import LayoutCuentas from "layout/LayoutCuentas";
import ListadoCuentas from "pages/cuentas/ListadoCuentas";
import EditarCuenta from "pages/cuentas/EditarCuenta";
import VerCuenta from "pages/cuentas/VerCuenta";
import RegistroCuentas from "pages/cuentas/RegistroCuentas";
import LayoutEtiquetas from "layout/LayoutEtiquetas";
import RegistrarEtiquetas from "pages/etiquetas/RegistrarEtiquetas";
import ListadoEtiquetas from "pages/etiquetas/ListadoEtiquetas";
import EditarEtiqueta from "pages/etiquetas/EditarEtiqueta";
import LayoutGastos from "layout/LayoutGastos";
import RegistrarGastos from "pages/gastos/RegistrarGastos";
import ListadoGastos from "pages/gastos/ListadoGastos";
import EditarGasto from "pages/gastos/EditarGasto";
import LayoutIngresos from "layout/LayoutIngresos";
import RegistrarIngresos from "pages/ingresos/RegistrarIngresos";
import ListadoIngresos from "pages/ingresos/ListadoIngresos";
import EditarIngresos from "pages/ingresos/EditarIngresos";
import LayoutAhorro from "layout/LayoutAhorro";
import RegistrarAhorro from "pages/ahorro/RegistrarAhorro";
import RegistrarMeta from "pages/ahorro/RegistrarMeta";
import ListadoMetas from "pages/ahorro/ListadoMetas"
import LayoutBalance from "layout/LayoutBalance";
import BalanceGeneral from "pages/balance/BalanceGeneral";
import BalanceCuenta from "pages/balance/BalanceCuenta";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/home" element={<Home />} />

        <Route path="/cuentas" element={<LayoutCuentas />} >
          <Route index element={<ListadoCuentas />} />
          <Route path="nueva" element={<RegistroCuentas />} />
          <Route path="editar/:id" element={<EditarCuenta />} />
          <Route path=":id" element={<VerCuenta />} />
        </Route>

        <Route path="/etiquetas" element={<LayoutEtiquetas />} >
          <Route index element={<ListadoEtiquetas />} />
          <Route path="nueva" element={<RegistrarEtiquetas />} />
          <Route path="editar/:id" element={<EditarEtiqueta />} />
          <Route path=":id" element={<EditarEtiqueta />} />
        </Route>

        <Route path="/gastos" element={<LayoutGastos />} >
          <Route index element={<ListadoGastos />} />
          <Route path="nuevo" element={<RegistrarGastos />} />
          <Route path="editar/:id" element={<EditarGasto />} />
        </Route>

        <Route path="/ingresos" element={<LayoutIngresos />} >
          <Route index element={<ListadoIngresos />} />
          <Route path="nuevo" element={<RegistrarIngresos />} />
          <Route path="editar/:id" element={<EditarIngresos />} />
        </Route>

        <Route path="/ahorro" element={<LayoutAhorro />} >
          <Route index element={<ListadoMetas />} />
          <Route path="meta" element={<RegistrarMeta />} />
          <Route path="nuevo" element={<RegistrarAhorro />} />
          <Route path="metas" element={<ListadoMetas />} />
        </Route>

        <Route path="/balance" element={<LayoutBalance />} >
          <Route index element={<BalanceGeneral />} />
          <Route path=":id" element={<BalanceCuenta />} />
        </Route>



      </Routes>

    </BrowserRouter>
  );
}

export default App;
